// extracted by mini-css-extract-plugin
export default {"btnContainer":"Bottom_btnContainer__ELtco"};